import React from 'react';

interface ProgressBarProps {
  progress: number;
  total: number;
  label?: string;
}

export function ProgressBar({ progress, total, label }: ProgressBarProps) {
  const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          {label || 'Evaluation Progress'}
        </span>
        <span className="text-sm text-gray-500">
          {progress}/{total} ({percentage}%)
        </span>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className="bg-gradient-to-r from-green-500 to-green-600 h-3 rounded-full transition-all duration-500 ease-in-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      <div className="text-center text-sm text-gray-600 mt-2">
        {percentage === 100 ? 'Complete!' : `Processing case ${progress}/${total}...`}
      </div>
    </div>
  );
}